export const initSlideComposition = () => ({
  type: "INIT_SLIDE_COMPOSITION"
});
export const initComponentConfig = () => ({
  type: "INIT_COMPONENT_CONFIG"
});

export const setSlideCompositionLabel = labels => ({
  type: "SET_SLIDE_COMPOSITION_LABELS",
  labels
});

export const setSlideCompositionIsPublic = isPublic => ({
  type: "SET_SLIDE_COMPOSITION_IS_PUBLIC",
  isPublic
});

export const setLayout = layout => ({
  type: "SET_SLIDE_LAYOUT",
  layout
});

export const setFondColor = color => ({
  type: "SET_FOND_COLOR",
  color
});

export const setBackgroundComponent = color => ({
  type: "SET_BACK_GROUND_COMPONENT_COLOR",
  color
});

export const setSideBar = sideBar => ({
  type: "SET_SIDE_BAR",
  sideBar
});

export const setSelectedCase = selectedCase => ({
  type: "SET_SELECTED_CASE",
  selectedCase
});

export const setSelectedComponent = selectedComponent => ({
  type: "SET_SELECTED_COMPONENT",
  selectedComponent
});

export const setIndicators = indicator => ({
  type: "SET_INDICATOR",
  indicator
});
export const setSlideId = slideId => ({
  type: "SET_SLIDE_ID",
  slideId
});
export const saveSlideComposition = resp => ({
  type: "SAVE_SLIDE_COMPOSITION",
  payload: resp
});

export const fetchSlide = slide => ({
  type: "FETCH_SLIDE",
  payload: slide
});

export const addComponent = component => ({
  type: "ADD_COMPONENT",
  component
});

export const addComponentData = data => ({
  type: "ADD_COMPONENT_DATA",
  data
});

export const addComponentConfig = config => ({
  type: "ADD_COMPONENT_CONFIG",
  config
});

export const setSlideComponentLabels = labels => ({
  type: "SET_SLIDE_COMPONENT_LABELS",
  labels
});

export const setComponent = newConfig => ({
  type: "SET_COMPONENT",
  newConfig
});

export const initComponentAction = () => ({
  type: "INIT_COMPONENT_ACTION"
});

export const setComponentAction = componentAction => ({
  type: "SET_COMPONENT_ACTION",
  componentAction
});

export const setSlideAction = slideAction => ({
  type: "SET_SLIDE_ACTION",
  slideAction
});

export const addComponentLabel = labels => ({
  type: "ADD_COMPONENT_LABELS",
  labels
});
export const addComponentIndicator = indicator => ({
  type: "ADD_COMPONENT_INDICATOR",
  indicator
});
export const addComponentType = componentType => ({
  type: "ADD_COMPONENT_TYPE",
  componentType
});

export const addNumberOfYears = yearsNumber => ({
  type: "ADD_NUMBER_OF_YEAR",
  yearsNumber
});

export const addMinValue = minValue => ({
  type: "ADD_MIN_VALUE",
  minValue
});

export const addMaxValue = maxValue => ({
  type: "ADD_MAX_VALUE",
  maxValue
});

export const addAnnexeCategory = category => ({
  type: "ADD_ANNEXE_CATEGORY",
  category
});

export const configNbrYear = nbrYears => ({
  type: "CONFIG_YEARS",
  nbrYears
});

export const setSlideIsEditable = isEditable => ({
  type: "SET_SLIDE_IS_EDITABLE",
  isEditable
});



// WEBPACK FOOTER //
// ./src/actions/actions/slideComposition.js